<template>
  <div id="Ehart">
    <div id="myChart" :style="{ width: '100%', height: '300px' }"></div>
  </div>
</template>

<script>
import { t } from 'i18next';
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/line");
require('echarts/lib/component/title');
require('echarts/lib/component/toolbox');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/grid');
require('echarts/lib/component/legend');
// 引入提示框和title组件
export default {
  name: "Ehart",
  components: {},
  data() {
    return {
      xAxis: [],
      yAxis: [],
      chartType: ""
    };
  },
  props: {
  },
  mounted() {
    this.drawLine();
  },
  watch: {
    xAxis: {
      handler(val) {
        this.xAxis = val;
        this.drawLine();
      },
      deep: true,
    },
    yAxis: {
      handler(val) {
        this.yAxis = val;
        this.drawLine();
      },
      deep: true,
    }
  },
  methods: {
    drawLine() {
      let that = this;
      var chartDom = document.getElementById('myChart');
      var myChart = echarts.init(chartDom);
      var option;
      var _xAxis = that.xAxis;
      var _yAxis = _xAxis.indexOf('No Data') > -1 ? [100] : that.yAxis;

      // console.log("that.xAxis.indexOf('No Data')", _xAxis, _xAxis.indexOf('No Data'));
      option = {
        color: ['#6F42FB', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
        title: {
          // text: 'Gradient Stacked Area Chart'
        },
        tooltip:
        {
          trigger: _xAxis.indexOf('No Data') > -1 ? '' : 'axis',
          axisPointer: {
            type: 'line',//cross line shadow
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: that.chartType == "Sales" ? '{b}<br/>{a}: ${c}' : '{b}<br/>{a}: {c}'
        },
        // legend: {
        //   data: [that.chartType],
        // },
        toolbox: {
          feature: {
            // saveAsImage: {
            //   title: 'Save As Image',
            // }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: that.xAxis.indexOf('No Data') > -1 ? [`${that.$t('enum.noData')}`] : that.xAxis,
            // nameLocation:'middle',
            axisLabel: {
              interval: 0,//间隔
              rotate: that.xAxis.length > 10 ? 45 : 0,//倾斜
              textStyle: {
                color: '#A0A0A0',
              }
            },
            axisLine: {
              lineStyle: {
                color: "#E5E8EF"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "solid", // 'solid' 'dashed' 'dotted'
                color: "#E5E8EF"
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: that.chartType == "Sales" ? '$ {value}' : '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed", // 'solid' 'dashed' 'dotted'
                color: "#E5E8EF"
              }
            }
          }
        ],
        series: [
          {
            name: that.chartType,
            type: 'line',
            stack: 'Total',
            smooth: true,
            showSymbol: false,
            // 背景色
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(58,132,255, 0.5)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            itemStyle: {
              normal: {
                // 曲线颜色
                lineStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#1FE8FF",
                      },
                      {
                        offset: 1,
                        color: "#6F42FB",
                      },
                    ],
                  },


                },
              },
            },
            emphasis: {
              focus: 'series'
            },
            data: _yAxis //[140, 232, 101, 264, 90, 340, 250]
          }
        ]
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/chart.vue